import {
    Box,
    chakra,
    Text,
    Divider,
} from '@chakra-ui/react';


import { CHIEF_PREV } from '../Components/info_all_members';
import { MemberCard } from '../Components/MemberCard';
import { useLanguage } from '../i18n/LanguageContext';

const Chief = () => {
    const { t } = useLanguage();
    return (
        <Box
            bg="#edf3f8" // 背景主題色：淺藍
            p={10}
            w="full"
        >
            <chakra.h1
                py={5}
                fontSize={40}
                fontWeight={'bold'}
                color={'gray.700'}>
                {t('formerDirectors.title')}
            </chakra.h1>
            <Divider />
            {CHIEF_PREV.map((cardInfo, index) => {
                return (
                    <>
                        <Box
                            mt={14}
                            borderRadius='md'
                            backgroundColor='#1E646E' // 職稱 title 深綠色
                        >
                            {index === CHIEF_PREV.length - 1 ?
                                <Text
                                    fontWeight='bold'
                                    fontSize='3xl'
                                    color='white'>
                                    {t('common.current')}
                                </Text> :
                                <Text
                                    fontWeight='bold'
                                    fontSize='3xl'
                                    color='white'>
                                    {t('formerDirectors.term')(index + 1)}
                                </Text>}
                        </Box>
                        <MemberCard {...cardInfo} index={index} group={'Chief'} />
                    </>
                )
            })}
        </Box>
    )
}
export default Chief;
